export default __webpack_public_path__ + "static/media/3151.24aa4677.jpg";